import { useFormikContext } from 'formik';
import React, { useEffect, useMemo } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { format } from 'date-fns';
import FieldFormControl from '../FieldFormControl';
import { safelyParseDate } from '@/utils/date';

const FormikDateField = ({ field, disabled, labelStyle }) => {
	const { values, setFieldValue, getFieldMeta, getFieldHelpers, getFieldProps } =
		useFormikContext();
	const { onBlur: onFieldBlur } = getFieldProps(field.name);
	const { error: errorMessage, touched } = getFieldMeta(field.name);
	const error = touched && Boolean(errorMessage);

	const { setTouched } = getFieldHelpers(field.name);

	const onBlur = (e) => {
		onFieldBlur(e);
		setTouched(true, true);
	};

	const dateValue = useMemo(() => {
		if (values[field.name]) {
			return safelyParseDate(values[field.name]);
		}
		return null;
	}, [values[field.name]]);

	const validation = field.field.validation;

	return (
		<FieldFormControl {...{ field, error, disabled, currentValue: dateValue, labelStyle }}>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<DatePicker
					name={field.name}
					value={dateValue}
					disabled={disabled}
					onChange={(newValue) => {
						// if passed in a date object, only store date without the time value
						if (newValue?.toISOString) {
							newValue = format(newValue, 'yyyy-MM-dd');
						}
						setFieldValue(field.name, newValue);
					}}
					onBlur={onBlur}
					{...(validation === 'past' && { maxDate: new Date() })}
					format='dd/MM/yyyy'
					slotProps={{
						textField: {
							fullWidth: true,
							error,
						},
					}}
				/>
			</LocalizationProvider>
		</FieldFormControl>
	);
};

export default FormikDateField;
